<template>
  <div>
    <component :is="compoment" />
  </div>
</template>
<script>

export default {
  name: "NavContainer",

  props: {
    campanha: {
      type: String,
      require: true
    }
  },

  data() {
    return {
      components: [
        {
          campanha: "vendas",
          compoment: () => import('./headers/HeaderArautos.vue')
        },
        {
          campanha: "retencao",
          compoment: () => import('./headers/HeaderArautos.vue')
        },
        {
          campanha: "recuperacao",
          compoment: () => import('./headers/HeaderArautos.vue')
        }
      ]
    };
  },

  computed: {
    compoment() {
      let campanha = this.campanha.replace(' ', '_').toLowerCase()
      return this.components
        .filter(comp => comp.campanha === campanha)
        .reduce((prev, current) => current, { campanha: "", compoment: "" }).compoment;
    }
  }
};
</script>



// WEBPACK FOOTER //
// HeaderCampanha.vue?b20896c6